import React, { useState, useEffect } from 'react'
import './Resetpassword.scss'
import Swal from "sweetalert2";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { apiUrl, apiUrl_image } from '../../constants';
import axios from "axios";
import useQueryToken from '../../components/useQueryToken'
import { Link, useHistory, useLocation } from "react-router-dom";
import { sha256, sha224 } from 'js-sha256';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '100%'

    },
}));

const Resetpassword = () => {
    const history = useHistory();
    const login_token = useQueryToken();
    const [newpassword, setNewpassword] = useState()
    const [confirmNewpassword, setconfirmNewpassword] = useState()

    useEffect(() => {
        if (!login_token) {
            history.push(`/error`);
        }
    }, [])
    const confirm = () => {
        if (!newpassword) {
            return Swal.fire("Error", "Password not null", "error");
        } else if (!confirmNewpassword) {
            return Swal.fire("Error", "Confirm password not null", "error");
        } else if (newpassword !== confirmNewpassword) {
            return Swal.fire("Error", "Password does not match", "error");
        } else if (newpassword.length < 8) {
            return Swal.fire("Error", "Password have to be at least 8 characters.", "error");
        } else if (confirmNewpassword.length < 8) {
            return Swal.fire("Error", "Confirm Password have to be at least 8 characters.", "error");
        } else {
            let send = {
                Password: sha256(newpassword),
                ConfirmPassword: sha256(confirmNewpassword)
            }
            console.log(send)
            axios.post(`${apiUrl}/resetpassword`, send, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${login_token}`,
                }
            })
                .then(async (res) => {
                    Swal.fire("Reset password successfully");
                })
                .catch((err) => {
                    Swal.fire("Error", `${err.response.data.message}`, "error");
                });
        }
    }

    const classes = useStyles();
    const [values, setValues] = React.useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const [valuesa, setValuesa] = React.useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const handleClickShowPassworda = () => {
        setValuesa({ ...valuesa, showPassword: !valuesa.showPassword });
    };

    const handleMouseDownPassworda = (event) => {
        event.preventDefault();
    };


    return (
        <div className="container page-resetpassword">
            <div className="page-resetpassword-title">
                <span >Reset password</span>
            </div>

            <div className="page-resetpassword-input">
                <FormControl className={clsx(classes.textField)} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={values.showPassword ? 'text' : 'password'}
                        value={newpassword}
                        onChange={(e) => setNewpassword(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                        labelWidth={105}
                    />
                </FormControl>
            </div>
            {newpassword && newpassword.length < 8 ?
                <span style={{color:"red"}}>**Password have to be at least 8 characters.</span>
                : null}
            <div className="page-resetpassword-input">
                <FormControl className={clsx(classes.textField)} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Confirm New Password</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={valuesa.showPassword ? 'text' : 'password'}
                        value={confirmNewpassword}
                        onChange={(e) => setconfirmNewpassword(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassworda}
                                    onMouseDown={handleMouseDownPassworda}
                                    edge="end"
                                >
                                    {valuesa.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                        labelWidth={170}
                    />
                </FormControl>
            </div>
            {confirmNewpassword && confirmNewpassword.length < 8 ?
                <span style={{color:"red"}}>**Confirm Password have to be at least 8 characters.</span>
                : null}
            <div className="page-resetpassword-button">
                <button className="btn btn-primary" onClick={() => confirm()}>Confirm</button>
            </div>
        </div>
    )
}

export default Resetpassword
